/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duplication_Only_Same_DayInputs */



/**
* | output |
* | --- |
* | "Duplication is only available for a time slot with a start and end on the same day" |
*
* @param {Duplication_Only_Same_DayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duplication_only_same_day = /** @type {((inputs?: Duplication_Only_Same_DayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplication_Only_Same_DayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Duplication is only available\nfor a time slot with a\nstart and end on the same\nday")
	return /** @type {LocalizedString} */ ("La duplication est disponible seulement\npour une plage horaire avec un\ndébut et une fin sur la même\njournée")
});